
import './App.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import LoginPage from './logincomponent/LoginPage'
import SurveryForm from './uicomponent/surveyform';
import ResultsPage from './resultcomponent/ResultPage'
import SummaryPage from './summarycomponent/SummaryPage'
import LogoutPage from './logoutcomponent/logoutpage';

import AdminLogin from './admincomponent/AdminLogin'; 
import AdminDashboard from './admincomponent/AdminDashboard';
import AdminHome from "./admincomponent/AdminHome";
import UploadUsers from './admincomponent/UploadUsers';
import CdpLoginPage from './cdpappcomponent/CdpLoginPage';

import CdpFeedback from './cdpappcomponent/CdpFeedback';
import CDPLogoutPage from './cdpappcomponent/cdplogoutpage';
function App() {
  return (
    <Router>
    <div className="App">
  
    
      <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/surveyform" element={<SurveryForm />} />
      <Route path="/results" element={<ResultsPage />} />
      <Route path="/summary" element={<SummaryPage />} />
      <Route path="/logout" element={<LogoutPage />} />


<Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} /> 
<Route path="/admin/home" element={<AdminHome />} /> 
      <Route path="/admin/uploadusers" element={<UploadUsers />} /> 

<Route path="/cdp" element={<CdpLoginPage/>} />
  

 <Route path="/cdp/cdpfeedback" element={<CdpFeedback/>} />
<Route path="/cdplogout" element={<CDPLogoutPage />} />
 

   </Routes>
    
      </div>
  
      </Router>
    );
}

export default App;
